import { Link } from "react-router-dom";
import useMeta from "@/hooks/useMeta";
import { works } from "@/mocks/works";
import { news } from "@/mocks/news";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import NewsPanel from "./components/NewsPanel";
import HotRanking from "./components/HotRanking";
import FeaturedTabs from "./components/FeaturedTabs";

export default function Home() {
  useMeta({
    title: "大象传媒 - 优质影视作品推荐与影视资讯平台",
    description:
      "大象传媒致力于提供丰富的电影、电视剧和综艺节目内容，涵盖最新影视资讯及推荐，满足用户多样化影视观看需求。",
    keywords:
      "大象传媒,影视作品,电影推荐,电视剧介绍,影视资讯,影视平台,影视内容",
  });

  const featured = [...works]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 5);

  const sortedNews = [...news].sort((a, b) => b.date.localeCompare(a.date));

  const stats = [
    { value: `${works.length}+`, label: "收录影视作品" },
    { value: `${news.length}+`, label: "影视资讯文章" },
    { value: "3", label: "内容分类频道" },
    { value: "每日", label: "资讯持续更新" },
  ];

  return (
    <>
      <h1 className="sr-only">大象传媒 - 优质影视作品推荐与影视资讯平台</h1>
      <HeroCarousel works={featured} />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto grid w-full grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:px-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl font-bold text-primary-700 md:text-3xl">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-foreground-500 md:text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </section>

      <CategoryEntries />

      <section className="mx-auto w-full px-4 pb-10 md:px-6 md:pb-12">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <NewsPanel items={sortedNews} />
          </div>
          <div>
            <HotRanking works={works} />
          </div>
        </div>
      </section>

      <FeaturedTabs works={works} />

      <section className="border-t border-background-200 bg-primary-50">
        <div className="mx-auto grid w-full grid-cols-1 items-center gap-8 px-4 py-12 md:grid-cols-2 md:px-6">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              关于我们
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专业、丰富、权威的影视内容平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              大象传媒专注于影视作品的展示与推荐，内容涵盖电影、电视剧、综艺等多种类型。我们以清晰的信息分类与便捷的浏览体验，帮助每一位影视爱好者快速了解作品信息与行业动态。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-1 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                开始浏览
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </Link>
              <Link
                to="/news"
                className="inline-flex items-center gap-1 rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
              >
                查看资讯
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-database-2-line", title: "内容丰富", desc: "多类型影视作品资料一站式浏览" },
              { icon: "ri-filter-3-line", title: "筛选精准", desc: "支持地区、年份、热度多维筛选" },
              { icon: "ri-search-eye-line", title: "搜索便捷", desc: "影视与资讯全站关键词模糊匹配" },
              { icon: "ri-bookmark-line", title: "收藏演示", desc: "本地保存感兴趣的作品清单" },
            ].map((feat) => (
              <div
                key={feat.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${feat.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                  {feat.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}